import React, { useEffect, useState } from "react";
import GitHubCalendar from "react-github-calendar";
import { AiFillStar, AiFillGithub } from "react-icons/ai";
import Section from "./Section";
import Reveal from "./Reveal";
import { profile } from "../data";

function GithubSection() {
  const [repos, setRepos] = useState([]);

  useEffect(() => {
    fetch(`https://api.github.com/users/${profile.githubUser}/repos?sort=updated&per_page=30`)
      .then((r) => (r.ok ? r.json() : []))
      .then((list) =>
        setRepos(
          list
            .filter((r) => !r.fork)
            .sort((a, b) => b.stargazers_count - a.stargazers_count)
            .slice(0, 6)
        )
      )
      .catch(() => setRepos([]));
  }, []);

  return (
    <Section id="github" title="Days I" accent="Code">
      <Reveal className="card calendar">
        <GitHubCalendar
          username={profile.githubUser}
          blockSize={13}
          blockMargin={4}
          fontSize={14}
          color="#8b5cf6"
          theme={{ level0: "#1c1b2e", level1: "#3b2a7a", level2: "#5b3fd1", level3: "#7c5cf0", level4: "#6cc4ff" }}
        />
      </Reveal>
      {repos.length > 0 && (
        <div className="projects-grid repos">
          {repos.map((r) => (
            <a key={r.id} className="card project" href={r.html_url} target="_blank" rel="noreferrer">
              <h3><AiFillGithub /> {r.name}</h3>
              <p className="muted">{r.description || "—"}</p>
              <p className="muted small">
                {r.language || "—"} · <AiFillStar /> {r.stargazers_count}
              </p>
            </a>
          ))}
        </div>
      )}
    </Section>
  );
}

export default GithubSection;
